import { render, staticRenderFns } from "./MyWatchlist.vue?vue&type=template&id=1bb7533c&scoped=true&"
import script from "./MyWatchlist.vue?vue&type=script&lang=js&"
export * from "./MyWatchlist.vue?vue&type=script&lang=js&"
import style0 from "./MyWatchlist.vue?vue&type=style&index=0&id=1bb7533c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb7533c",
  null
  
)

export default component.exports